import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { VinDecodeComponent, getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, getPhotoCaptureContextId, photoCaptureResetContextAction, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureAttachmentInfo, getPhotoCaptureAttachedArtifactIds, photoCaptureUpdateAttachedArtifactIdSuccessAction } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationAnswerList, getQuestionnaireEvaluationParentQuestionId } from "../../../domain/questionnaireEvaluation";
import { getVehicleInfoData, getSelectedInfoEntries, onInvalidVinData, onValidVinData, onVehicleInfoUpdated, onVinUpdated, onResetVehicleInfo, onFlyoutClicked } from "../../../domain/vehicleInfo";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme, getGPCErrorState } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        vehicleInfoData: getVehicleInfoData(state),
        selectedInfoEntries: getSelectedInfoEntries(state),
        warningMessage: getGPCErrorState(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        answerList: getQuestionnaireEvaluationAnswerList(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state)
    };
};
/**
 * onValidVinData, onInvalidVinData, onVinUpdated, onVehicleInfoUpdated these action will be implemented in coming sprint
 */
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureResetContextAction,
        onValidVinData,
        onInvalidVinData,
        onVinUpdated,
        onVehicleInfoUpdated,
        onResetVehicleInfo,
        photoCaptureUpdateAttachedArtifactIdSuccessAction,
        onFlyoutClicked
    }, dispatch);
};
export const ConnectedVinDecodeComponent = connect(mapStateToProps, mapDispatchToProps)(VinDecodeComponent);
//# sourceMappingURL=ConnectedVinDecodeComponent.js.map